import { render, staticRenderFns } from "./IconHernieuwbareKoeling.vue?vue&type=template&id=aebb68ba"
import script from "./IconHernieuwbareKoeling.vue?vue&type=script&lang=ts"
export * from "./IconHernieuwbareKoeling.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports